export interface SaleorError {
  field: string
  message: string
}

export interface Metadata {
  key: string
  value: string
}

interface Medium {
  url: string
  id: string
}

export interface Order {
  lines: Line[]
  total: Total
  metafield: string
  status: string
  deliveryMethod: DeliveryMethod
  metadata: Metadata[]
  selectedRentalDate?: string
}

interface Total {
  gross: Money
}

interface Pricing {
  price: Price
}

export interface Money {
  amount: number
  currency: string
}

export interface Variant {
  id: string
  name: string
  metadata: Metadata[]
  pricing: Pricing
  product?: Product
}

export interface CartStructure {
  product: Product
  amount: number
}

export interface ShippingMethod {
  id: string
  name: string
  active: boolean
  message: string
  price: Money
}

interface Price {
  currency: string
  net: Money
  gross: Money
  tax: Money
}

interface Category {
  name: string
}

export interface Line {
  quantity: number
  totalPrice: TotalPrice
  id: string
  variant: Variant | RentalDataPlanVariant | RentalTerminalVariant
}

export interface TotalPrice {
  gross: Money
}

export interface Product {
  id: string
  name: string
  metadata: Metadata[]
  media: Medium[]
  description: string
  variants: Variant[]
  category: Category
  slug?: string
}

export interface DeliveryMethod {
  id: string
  name: string
  price: Money
}

export interface User {
  firstName: string
  lastName: string
  email: string
  organization: Organization
  title: any
  mobilePhoneNumber: string
  profile: Profile
  groups: Group[]
  shippingAddress: ShippingAddress
  hasTotp: boolean
  id: string
}

interface Organization {
  id: string
  name: string
}

interface Profile {
  id: string
  imageUrl: string
}

interface Group {
  id: string
  name: string
}

interface ShippingAddress {
  address1: string
  address2: any
  city: string
  zipCode: string
  country: string
}

export interface CheckoutLineInput {
  quantity: number
  variantId: string
}

export interface RentalDataPlanVariant extends Variant {
  dataPackageGB: string
}

export interface RentalTerminalVariant extends Variant {
  rentalVariantSlug: string
}

export function isRentalDataPlanVariant(
  variant: Variant | RentalDataPlanVariant | RentalTerminalVariant,
): variant is RentalDataPlanVariant {
  return "dataPackageGB" in variant && variant.dataPackageGB !== null
}

export function isRentalTerminalVariant(
  variant: Variant | RentalDataPlanVariant | RentalTerminalVariant,
): variant is RentalTerminalVariant {
  return "rentalVariantSlug" in variant && variant.rentalVariantSlug !== null
}
